import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { SEARCH_FIELD_NAMES, STEEL_MAKER_NAME, STEEL_MILLS_AICHI, STEEL_MILLS_KOBE, STEEL_MILLS_JFE
  , STEEL_MILLS_NSC } from '../../../constants';
import type { SelectOptionIndexed } from '../../../types/common';

const steelMillsNsc: SelectOptionIndexed[] = Object.values(STEEL_MILLS_NSC).map((mill) => ({
  index: mill.index,
  label: mill.nameEnglish,
  value: mill.nameEnglish,
}));
const steelMillsAichi: SelectOptionIndexed[] = Object.values(STEEL_MILLS_AICHI).map((mill) => ({
  index: mill.index,
  label: mill.nameEnglish,
  value: mill.nameEnglish,
}));
const steelMillsKobe: SelectOptionIndexed[] = Object.values(STEEL_MILLS_KOBE).map((mill) => ({
  index: mill.index,
  label: mill.nameEnglish,
  value: mill.nameEnglish,
}));
const steelMillsJfe: SelectOptionIndexed[] = Object.values(STEEL_MILLS_JFE).map((mill) => ({
  index: mill.index,
  label: mill.nameEnglish,
  value: mill.nameEnglish,
}));


interface SelectMillEnProps {
  selectedSteelMakerEn: string;
  value: string;
  disabled?: boolean;
  onChangeMill: (fieldName: string, value: string) => void;
}

const SelectMillEn = ({ selectedSteelMakerEn, value, disabled = false, onChangeMill }: SelectMillEnProps): JSX.Element => {
  // console.log(name, value);
  const steelMills = [...steelMillsNsc, ...steelMillsAichi, ...steelMillsKobe, ...steelMillsJfe].sort((a, b) => a.index - b.index);
  const [selectedOption, setSelectedOption] = useState<SelectOptionIndexed | null>(null);
  const [options, setOptions] = useState<SelectOptionIndexed[]>(steelMills);
  // 堺(阪神)や大分(光鋼管)のように半角カッコが入っているミルはダブルクォーテーションで囲ってあるため
  // 表示時にはダブルクォーテーションを外す
  const getOptionLabel = (option: SelectOptionIndexed): string => option.label.replace(/"/g, '');

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (selectedSteelMakerEn === STEEL_MAKER_NAME.NIPPONSTEEL.EN) {
      setOptions(() => steelMillsNsc);
    } else if (selectedSteelMakerEn === STEEL_MAKER_NAME.AICHISTEEL.EN) {
      setOptions(() => steelMillsAichi);
    } else if (selectedSteelMakerEn === STEEL_MAKER_NAME.KOBESTEEL.EN) {
      setOptions(() => steelMillsKobe);
      } else if (selectedSteelMakerEn === STEEL_MAKER_NAME.JFESTEEL.EN) {
      setOptions(() => steelMillsJfe);
    } else {
      setOptions(() => steelMills);
    }
  }, [selectedSteelMakerEn]);

  useEffect(() => {
    if (value !== '') {
      const newSelectedOption: SelectOptionIndexed | undefined = options.find((option) => option.value === value);
      // console.log(newSelectedOption);
      if (newSelectedOption !== undefined) {
        setSelectedOption(newSelectedOption);
      }
    } else {
      setSelectedOption(null);
      onChangeMill(SEARCH_FIELD_NAMES.MILL_EN, '');
    }
  }, [value]);

  // EVENT HANDLER
  // ================================================================================

  const handleOptionChange = (option: SelectOptionIndexed | null): void => {
    // console.log(option);
    setSelectedOption(option);
    const newValue: string = option.value;
    onChangeMill(SEARCH_FIELD_NAMES.MILL_EN, newValue);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Select
        id={SEARCH_FIELD_NAMES.MILL_EN}
        name={SEARCH_FIELD_NAMES.MILL_EN}
        className="react-select-container"
        classNamePrefix="react-select"
        value={selectedOption}
        options={options}
        getOptionLabel={getOptionLabel}
        onChange={handleOptionChange}
        placeholder="Select..."
        isDisabled={disabled}
      />
    </>
  );
};

export default SelectMillEn;
